import { VendorCategoryDetailPage } from '@/features/vendor-category/pages/VendorCategoryDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor-category/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorCategoryDetailPage,
})
